export const GET_USER_DASHBOARD = "GET_USER_DASHBOARD";
export const GET_LEADERBOARD = "GET_LEADERBOARD";
export const DELETE_SELECTED_ITEMS = "DELETE_SELECTED_ITEMS";
export const SET_SELECTED_ITEMS = "SET_SELECTED_ITEMS";
export const LAST_LEADERBOARD_ID = "LAST_LEADERBOARD_ID";
export const GET_ROUND_SLIDER_INFO = "GET_ROUND_SLIDER_INFO";